import React from "react";
import { IonSelect, IonSelectOption } from "@ionic/react";

const _countOptions = (array) => {
  var count = 0;
  array.map((att) => {
    count += att.length;
    return true;
  });
  return count;
};

export const sortFunction = (x, y) => {
  var pre = ["string", "number", "bool"];
  if (typeof x !== typeof y)
    return pre.indexOf(typeof y) - pre.indexOf(typeof x);

  if (x === y) return 0;
  else return x > y ? 1 : -1;
};

const arraysEqual = (a, b) => {
  if (a === b) return true;
  if (a == null || b == null) return false;
  if (a.length !== b.length) return false;
  for (var i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
};

export const findCombination = (finalComb, product) => {
  const prodCombis = [...product.combinations];
  var todasLasCombinaciones = {};
  for (let i in prodCombis) {
    var combs = prodCombis[i].data;
    todasLasCombinaciones[i] = [];
    combs.forEach((key, val) => {
      todasLasCombinaciones[i].push(key.value);
    });
  }
  var finalIndex = null;
  for (let j in todasLasCombinaciones) {
    if (
      arraysEqual(
        todasLasCombinaciones[j].sort(sortFunction),
        finalComb.sort(sortFunction)
      )
    ) {
      finalIndex = j;
    }
  }

  return prodCombis[finalIndex];
};

export const Attributes = ({
  product,
  setProduct,
  curCombi,
  setCurCombi,
  includeTitle = true,
  small = false,
  allLineal = false,
}) => {
  const handleInputRadio = (e) => {
    const currentInput = { ...curCombi };
    currentInput[e.target.name] = e.target.value;
    setCurCombi(currentInput);

    var finalComb = [];
    for (let i in currentInput) {
      finalComb.push(currentInput[i]);
    }
    const combination = findCombination(finalComb, product);
    const curProd = { ...product };

    if (
      combination &&
      combination.hasOwnProperty("price") &&
      combination.price
    ) {
      curProd["newPrice"] = combination.price;
    } else {
      delete curProd["newPrice"];
    }
    setProduct(curProd);
  };

  const _callOptions = (array) => {
    return array.map((att, indx) => {
      return (
        <IonSelectOption key={indx} value={att}>
          {att}
        </IonSelectOption>
      );
    });
  };

  const _loadcombisifhave = () => {
    if (product.hasOwnProperty("combinations") && product.combinations.length) {
      let attributes = {};
      product.combinations.forEach((k, v) => {
        k.data.forEach((kk, vv) => {
          if (attributes[kk.attribute_group]) {
            if (!attributes[kk.attribute_group].includes(kk.value)) {
              attributes[kk.attribute_group].push(kk.value);
            }
          } else {
            attributes[kk.attribute_group] = [];
            attributes[kk.attribute_group].push(kk.value);
          }
        });
      });

      var collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: "base",
      });

      return Object.entries(attributes)
        .sort(collator.compare)
        .map((entry, indexx) => {
          return entry[1].length ? (
            <div
              className={`attributesDisponibles ${small ? "small" : ""}`}
              key={indexx}
            >
              {includeTitle ? (
                <h4 className="attribute">
                  {entry[0].charAt(0).toUpperCase() + entry[0].slice(1)}
                </h4>
              ) : null}
              <div className="inputs">
                <div className="inputCirculos">
                  {(entry[0] === "colores" ||
                    entry[0].toLowerCase().includes("color") ||
                    (entry[1].length > 4 && _countOptions(entry[1]) > 35)) &&
                  !allLineal ? (
                    <IonSelect
                      okText="Elegir"
                      cancelText="Cancelar"
                      onIonChange={(e) => {
                        handleInputRadio(e);
                      }}
                      name={"group_" + indexx}
                      className="selectColor"
                      placeholder={
                        "Elegir " +
                        entry[0].charAt(0).toUpperCase() +
                        entry[0].slice(1)
                      }
                    >
                      {_callOptions(entry[1])}
                    </IonSelect>
                  ) : (
                    <>
                      {entry[1].map((att, indx) => {
                        return (
                          <div
                            key={"attribute_" + indx}
                            style={{ textAlign: "center" }}
                            className={
                              "botonactivado" +
                              (att.length > 3 ? " esmaslargo" : "")
                            }
                          >
                            <input
                              onInput={(event) => {
                                handleInputRadio(event);
                              }}
                              name={"group_" + indexx}
                              type="radio"
                              value={att}
                            />
                            <label
                              className={"boton_" + indx + " grupo_" + indexx}
                            >
                              {att}
                            </label>
                          </div>
                        );
                      })}
                    </>
                  )}
                </div>
              </div>
            </div>
          ) : (
            ""
          );
        });
    } else {
      return null;
    }
  };

  return <>{_loadcombisifhave(product)}</>;
};
